import type { NodeType } from '@byokapp/types'
import { SidebarContent } from '@/components/ui/sidebar'

interface PaletteItem {
  type: NodeType
  label: string
  description: string
  color: string
}

const FREE_NODES: PaletteItem[] = [
  {
    type: 'prompt',
    label: 'Prompt',
    description: 'Text input',
    color: 'border-indigo-700/60 text-indigo-300',
  },
  {
    type: 'text-to-image',
    label: 'Text to Image',
    description: 'Generate image',
    color: 'border-violet-700/60 text-violet-300',
  },
  {
    type: 'output',
    label: 'Output',
    description: 'Display result',
    color: 'border-emerald-700/60 text-emerald-300',
  },
]

export function BlueprintSidebar() {
  function onDragStart(e: React.DragEvent, type: NodeType) {
    e.dataTransfer.setData('application/byokapp-node-type', type)
    e.dataTransfer.effectAllowed = 'move'
  }

  return (
    <SidebarContent>
      <div className="flex flex-col gap-1 p-4">
        <p className="text-[10px] font-semibold uppercase tracking-widest text-muted-foreground mb-2">
          Nodes
        </p>
        <div className="flex flex-col gap-1.5">
          {FREE_NODES.map((item) => (
            <div
              key={item.type}
              draggable
              onDragStart={(e) => onDragStart(e, item.type)}
              className={`cursor-grab active:cursor-grabbing rounded border bg-zinc-900 px-3 py-2 select-none hover:bg-zinc-800 transition-colors ${item.color}`}
            >
              <p className="text-xs font-medium">{item.label}</p>
              <p className="text-[10px] text-zinc-500">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </SidebarContent>
  )
}
